import { render, staticRenderFns } from "./p04.vue?vue&type=template&id=e94122b6&scoped=true&"
import script from "./p04.vue?vue&type=script&lang=js&"
export * from "./p04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94122b6",
  null
  
)

export default component.exports